import { TCommandParamsIfExists } from '../interfaces/command/CommandTypeUtils'
import { AsyncExecutableCmd } from '../interfaces/command/AsyncExecutableCmd'
import { AsyncCmdExecuteFunction } from '../interfaces/command/AsyncCmdExecuteFunction'
import { AsyncExecutableCommand } from './AsyncExecutableCommand'

/**
 * Returns a type safe representation of an executable command
 * (type AsyncExecutableCommand)
 *
 * @param arg
 */
export function makeAsyncExecutableCommand<
  T,
  K extends keyof T,
  E
>(arg: {
  command: K;
  params?: TCommandParamsIfExists<T, K>;
  execFn: AsyncCmdExecuteFunction<T, K, E>;
}): AsyncExecutableCmd<T, K, E> {
  return new AsyncExecutableCommand(arg)
}
